import { Badge } from "@/components/ui/badge";
import { PhoneCall, Bot } from "lucide-react";

export const ACTION_LABEL = {
  find_customer: "Customer lookup", book_appointment: "Booked appointment", customer_appointments: "Listed appointments", reschedule_appointment: "Rescheduled",
  cancel_appointment: "Cancelled appointment", account_summary: "Balance check", send_statement: "Statement sent", send_invoice: "Invoice sent",
};
const ACTION_CLASS = {
  book_appointment: "bg-emerald-100 text-emerald-800", reschedule_appointment: "bg-blue-100 text-blue-800", cancel_appointment: "bg-red-100 text-red-700",
  send_statement: "bg-purple-100 text-purple-800", send_invoice: "bg-purple-100 text-purple-800", account_summary: "bg-amber-100 text-amber-800",
  find_customer: "bg-slate-100 text-slate-700", customer_appointments: "bg-slate-100 text-slate-700",
};

export const actionLabel = (a) => ACTION_LABEL[a] || a.replace(/^(post|put|delete|patch)_/, (m) => ({ post_: "Created ", put_: "Updated ", delete_: "Deleted ", patch_: "Updated " }[m])).replace(/_/g, " ");
export const fmtWhen = (iso) => new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export const ActivityRow = ({ item, compact = false }) => (
  <div className={`flex items-start gap-3 ${compact ? "py-2" : "py-3"}`} data-testid="activity-row">
    <div className={`mt-0.5 shrink-0 rounded-full p-1.5 ${item.via_api_key ? "bg-indigo-50 text-indigo-600" : "bg-slate-100 text-slate-500"}`}>{item.via_api_key ? <PhoneCall className="w-3.5 h-3.5" /> : <Bot className="w-3.5 h-3.5" />}</div>
    <div className="flex-1 min-w-0">
      <div className="flex flex-wrap items-center gap-2">
        <Badge className={`${ACTION_CLASS[item.action] || "bg-slate-100 text-slate-700"} text-xs`} data-testid="activity-action">{actionLabel(item.action)}</Badge>
        {!item.ok && <Badge className="bg-red-100 text-red-700 text-xs" data-testid="activity-failed">FAILED</Badge>}
        {item.customer_name && <span className="text-sm font-medium text-slate-800 truncate" data-testid="activity-customer">{item.customer_name}</span>}
      </div>
      <p className="text-sm text-slate-600 truncate" title={item.summary} data-testid="activity-summary">{item.summary}</p>
      <p className="text-xs text-slate-400">{fmtWhen(item.at)} · {item.key_name ? `key: ${item.key_name}` : item.principal}</p>
    </div>
  </div>
);
